import {css} from "@panda/css";

export const bottomSheetMotionEnterStyle = css({
    animationDuration: "var(--transition-duration-sheet)",
    animationTimingFunction: "ease-out",
    animationFillMode: "both"
});

export const bottomSheetMotionExitStyle = css({
    animationDuration: "var(--transition-duration-sheet)",
    animationTimingFunction: "ease-in",
    animationFillMode: "both"
});

export const bottomSheetSlideInStyle = css({
    animationName: "bottomSheetSlideIn"
});

export const bottomSheetSlideOutStyle = css({
    animationName: "bottomSheetSlideOut"
});

export const bottomSheetOverlayFadeInStyle = css({
    animationName: "bottomSheetOverlayFadeIn"
});

export const bottomSheetOverlayFadeOutStyle = css({
    animationName: "bottomSheetOverlayFadeOut"
});
import {css} from "@panda/css";

export const bottomSheetMotionEnterStyle = css({
    animationDuration: "var(--transition-duration-sheet)",
    animationTimingFunction: "ease-out",
    animationFillMode: "both"
});

export const bottomSheetMotionExitStyle = css({
    animationDuration: "var(--transition-duration-sheet)",
    animationTimingFunction: "ease-in",
    animationFillMode: "both"
});

export const bottomSheetSlideInStyle = css({
    animationName: "bottomSheetSlideIn"
});

export const bottomSheetSlideOutStyle = css({
    animationName: "bottomSheetSlideOut"
});

export const bottomSheetOverlayFadeInStyle = css({
    animationName: "bottomSheetOverlayFadeIn"
});

export const bottomSheetOverlayFadeOutStyle = css({
    animationName: "bottomSheetOverlayFadeOut"
});
